// extracted by mini-css-extract-plugin
export default {"modal":"Z0Jf7","root":"_1pEiq","footer":"_1_xUi"};